import { Tooltip } from "@mui/material";
import SmartPredictSvg from "SvgIcons/SmartPredictSvg";

type Props = {
    isVisible?: boolean;
};

const ConvoAutofillIndicator = ({ isVisible }: Props) => {
    if (!isVisible) {
        return null;
    }

    return (
        <Tooltip title="Autofilled answer">
            <span style={{ display: "inline-flex", alignItems: "center" }}>
                <SmartPredictSvg width="16" height="16" />
            </span>
        </Tooltip>
    );
};

export default ConvoAutofillIndicator;
